import { css } from '@bts-web/utils-style-engine';

export const rowStyles = css({
  display: 'flex',
  flexDirection: 'column',
});

export const rowWithBordersStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'medium',
  py: 'medium',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'neutrals.divider',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'neutrals.divider',
});

export const fiatStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'extra_small_2',
  pb: 'extra_small_2',
});

export const assetNameStyles = css({
  fontSize: 'title.medium_medium',
  fontWeight: 'title.medium_medium',
  letterSpacing: 'title.medium_medium',
  lineHeight: 'title.medium_medium',
  color: 'neutrals.text_primary',
});

export const helperRowStyles = css({
  pt: 'small',
  pb: 'small',
});

export const helperTextStyles = css({
  fontSize: 'caption.small_light',
  fontWeight: 'caption.small_light',
  letterSpacing: 'caption.small_light',
  lineHeight: 'caption.medium_medium',
  color: 'neutrals.text_primary',
});

export const availableRowStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'medium',
});

export const availableAssetInfoStyles = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: 'extra_small_3',
  minWidth: 0,
});

export const availableTrailingStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: 'extra_small_3',
});

export const availableLabelStyles = css({
  fontSize: 'caption.small',
  fontWeight: 'caption.small',
  letterSpacing: 'caption.small',
  lineHeight: 'caption.small',
  color: 'neutrals.text_secondary',
});

export const availableNameStyles = css({
  fontSize: 'label.medium_medium',
  fontWeight: 'label.medium_medium',
  letterSpacing: 'label.medium_medium',
  lineHeight: 'label.medium_medium',
  color: 'neutrals.text_primary',
});

export const disclaimerSectionStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'extra_small_2',
  borderRadius: '8px',
  border: '2px solid',
  borderColor: 'warning.stroke_primary',
  padding: 'small',
  fontSize: 'body.medium',
});

export const disclaimerTitleStyles = css({
  color: 'warning.stroke_primary',
});
